import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import { Link } from 'react-scroll';
import { FiDownload, FiArrowRight } from 'react-icons/fi';
import { API_BASE_URL as API_BASE } from '../services/api';

const Hero = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [stats, setStats] = useState([
    { end: 0, suffix: '+', label: 'Loyiha' },
    { end: 0, suffix: '+', label: 'Kvartira' },
    { end: 0, suffix: '', label: 'Quruvchi' },
    { end: 0, suffix: '+', label: 'Foydalanuvchi' },
  ]);

  useEffect(() => {
    Promise.all([
      fetch(`${API_BASE}/projects/`).then((r) => r.json()).catch(() => ({})),
      fetch(`${API_BASE}/apartments/`).then((r) => r.json()).catch(() => ({})),
      fetch(`${API_BASE}/builders/`).then((r) => r.json()).catch(() => ({})),
    ]).then(([projects, apartments, builders]) => {
      const proj = projects.count ?? (Array.isArray(projects) ? projects.length : 0);
      const apt = apartments.count ?? (Array.isArray(apartments) ? apartments.length : 0);
      const bld = builders.count ?? (Array.isArray(builders) ? builders.length : 0);
      setStats([
        { end: proj, suffix: proj > 0 ? '+' : '', label: 'Loyiha' },
        { end: apt, suffix: apt > 0 ? '+' : '', label: 'Kvartira' },
        { end: bld, suffix: '', label: 'Quruvchi' },
        { end: 0, suffix: '+', label: 'Foydalanuvchi' },
      ]);
    });
  }, []);

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.15, duration: 0.6, ease: 'easeOut' },
    }),
  };

  return (
    <section className="hero" id="hero">
      <div className="hero-bg-circle hero-bg-circle-1" />
      <div className="hero-bg-circle hero-bg-circle-2" />

      <div className="hero-inner" ref={ref}>
        <div className="hero-content">
          <motion.div
            className="hero-badge"
            variants={fadeUp}
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
            custom={0}
          >
            <span className="hero-badge-dot" />
            Yangi hayot ostonasi
          </motion.div>

          <motion.h1
            className="hero-title"
            variants={fadeUp}
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
            custom={1}
          >
            Orzuingizdagi uyni toping —{' '}
            <span className="gold-text">bir platformada</span>
          </motion.h1>

          <motion.p
            className="hero-desc"
            variants={fadeUp}
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
            custom={2}
          >
            OSTONA — bu zamonaviy kvartira qidirish, 3D ko'rish, onlayn shartnoma
            tuzish va ipoteka kalkulyatorini o'z ichiga olgan yagona platforma.
            Qurilish kompaniyalari bilan to'g'ridan-to'g'ri bog'laning.
          </motion.p>

          <motion.div
            className="hero-buttons"
            variants={fadeUp}
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
            custom={3}
          >
            <Link to="download" smooth duration={600} offset={-70}>
              <button className="btn-gold">
                <FiDownload /> Ilovani yuklab oling
              </button>
            </Link>
            <Link to="features" smooth duration={600} offset={-70}>
              <button className="btn-outline">
                Batafsil <FiArrowRight />
              </button>
            </Link>
          </motion.div>

          <motion.div
            className="hero-stats"
            variants={fadeUp}
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
            custom={4}
          >
            {stats.map((stat, i) => (
              <div className="hero-stat" key={i}>
                <div className="hero-stat-number">
                  {inView && (
                    <CountUp end={stat.end} duration={2.5} suffix={stat.suffix} />
                  )}
                </div>
                <div className="hero-stat-label">{stat.label}</div>
              </div>
            ))}
          </motion.div>
        </div>

        <motion.div
          className="hero-visual"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={inView ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.8, delay: 0.3, ease: 'easeOut' }}
        >
          <div className="hero-phone-glow" />
          <div className="hero-phone">
            <div className="hero-phone-inner">
              <img src="/logo.jpg" alt="OSTONA" className="hero-phone-logo" />
              <span className="hero-phone-text">OSTONA</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
